import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { resolveImg } from "../lib/api";

export default function MasonryGallery({ items, testId = "masonry-gallery" }) {
  if (!items?.length) {
    return (
      <div data-testid="empty-gallery" className="text-white/50 py-24 text-center text-sm tracking-widest uppercase">
        Sin proyectos por ahora.
      </div>
    );
  }
  return (
    <div className="masonry-3" data-testid={testId}>
      {items.map((p, i) => (
        <motion.div
          key={p.slug}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.7, delay: (i % 6) * 0.06, ease: [0.2, 0.8, 0.2, 1] }}
        >
          <Link
            to={`/proyecto/${p.slug}`}
            data-testid={`gallery-item-${p.slug}`}
            className="group block relative overflow-hidden"
          >
            <div className="overflow-hidden bg-[var(--surface)]">
              <img
                src={resolveImg(p.cover)}
                alt={p.title}
                loading="lazy"
                className="w-full h-auto img-hover"
              />
            </div>
            <div className="mt-3 flex items-baseline justify-between">
              <div>
                <p className="font-display uppercase text-base tracking-wide group-hover:text-[var(--magenta)] transition-colors">
                  {p.title}
                </p>
                <p className="text-[11px] tracking-[0.25em] uppercase text-white/40 font-display mt-1">
                  {p.location || "—"} {p.year ? `· ${p.year}` : ""}
                </p>
              </div>
              <span className="text-[10px] tracking-[0.3em] uppercase text-white/30 font-display">
                {p.category}
              </span>
            </div>
          </Link>
        </motion.div>
      ))}
    </div>
  );
}
